import { render, staticRenderFns } from "./LeftSession1.vue?vue&type=template&id=bddfc56e&scoped=true"
import script from "./LeftSession1.vue?vue&type=script&lang=js"
export * from "./LeftSession1.vue?vue&type=script&lang=js"
import style0 from "./LeftSession1.vue?vue&type=style&index=0&id=bddfc56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddfc56e",
  null
  
)

export default component.exports